/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SendMessageRequestDto { 
    /**
     * id чата
     */
    chatId: string;
    /**
     * текст сообщения
     */
    messageText: string;
    /**
     * id сообщения, на которое идет ответ
     */
    replyMessageId?: string | null;
    /**
     * цитата из сообщения, на которое идет ответ
     */
    replyMessageText?: string | null;
}

